<template>
    <div class="eic-dashboard">
        <header>
            <div class="container-fluid bg-white mb-5">
                <div class="container pl-1 pt-3 pb-3">
                    <a href="https://www.jmirpublications.com" target="_blank">
                        <img style="width: 255px;" src="/public/images/JMIR-logo@2x.png">
                    </a>
                </div>
            </div>
        </header>

        <div class="container" style="color: black; width: 90%; max-width: 100%">
            <div class="filters">
                <div class="filter-row">
                    <input class="filter" v-model="title" placeholder="Title" type="text" />
                    <input class="filter" v-model="affiliation" placeholder="Affiliation" type="text" />
                    <input class="filter" v-model="abstract" placeholder="Abstract" type="text" />
                    <input class="filter" v-model="keywords" placeholder="Keywords" type="text" />
                </div>
                <!-- <div class="filter-row">
                    <select class="filter" @change="addStatus($event)">
                        <option v-for="status in articleStatuses" :key="status" :value="status.granular_status_id">{{ status.granular_status_id }} - {{ status.label }}</option>
                    </select>
                </div> -->
                <!-- <div class="list-row">
                    <div v-for="status in statuses" :key="status"> 
                        <a style="color: red; cursor:pointer;" @click="removeStatus(status)"><i class="fas fa-trash-alt"></i></a> 
                        {{ status.granular_status_id }} - {{ status.label }}
                    </div>
                </div> -->
                <div class="filter-row"> 
                    <button class="filter-button" @click.prevent="filterResults">Filter Results</button>  
                </div>
            </div>
        </div>

        <div class="container table-container" style="width: 90%; max-width: 100%">
            <div class="filter-row" v-if="count">
                <span>{{ count }} Results</span>
                <div style="margin-left: 8px">
                    <span 
                        class="fas fa-angle-double-left" 
                        @click="left"
                        style="cursor: pointer">
                    </span>
                    <span> {{ page }} / {{ getPages }} </span>
                    <span 
                        class="fas fa-angle-double-right" 
                        @click="right"
                        style="cursor: pointer">
                    </span>
                </div>
            </div>
            <table class="table table-striped">
                <thead>
                    <th>Occurrences</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th colspan="2">Orcid</th>
                </thead>
                
                <tbody v-if="!loading">
                    <template v-for="(author, authorIndex) in data">
                        <tr style="background-color: #EEE">
                            <td>{{ author.articles.length }}</td>
                            <td>{{ author.name }}</td>
                            <td><a :href="`mailto:${author.email}`">{{ author.email }}</a></td>
                            <td colspan="2">{{ author.orcid }}</td>
                        </tr>
                        <tr style="background-color: #FFF" v-if="author.articles.length">
                            <td></td>
                            <td>MS #</td>
                            <td>Title</td>
                            <td>URL</td>
                            <td>Submitted</td>
                        </tr>
                        <tr v-for="(article, articleIndex) in author.articles" :key="articleIndex" style="background-color: #FFF">
                            <td></td>
                            <td>{{ article.id }}</td>
                            <td>{{ article.title }}</td>
                            <td><a :href="article.html_url">{{ article.doi }}</a></td>
                            <td>{{ article.submitted_at }}</td>
                        </tr>
                    </template>
                </tbody>
                <tbody v-if="loading" style="text-align:center">
                    <td colspan="5"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></td>
                </tbody>
                <tbody v-if="!data && !loading" style="text-align:center">
                    <td colspan="5">No results to display!</td>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data'],
    name: 'dashboard-table',
    data() {
        return {
            count: 0,
            page: 1,
            data: [],
            articleStatuses: {},
            keywords: null,
            title: null,
            abstract: null,
            affiliation: null,
            statuses: [],
            selected: null,
            limit: 25,
            loading: false
        }
    },
    async beforeCreate() {
        // let articleStatuses = await axios.get('https://nursing.jmir.org/v1/status/')
        
        // this.articleStatuses = articleStatuses.data.filter(status => {
        //     return !status.granular_status_id.includes(',')
        // })
    },
    methods: {
        // removeStatus: function(status) {
        //     this.statuses.splice(this.statuses.indexOf(status), 1)
        // },
        // // Match the status id to the article status array and push label and id to the selected array
        // addStatus: function(status) {
        //     for (let search of this.articleStatuses) {
        //         if (status.target.value == search.granular_status_id) {
        //             this.statuses.push({
        //                 label: search.label,
        //                 granular_status_id: search.granular_status_id
        //             })
        //         }
        //     }
        // },
        // Build the query string and make the query
        filterResults: async function() {
            if (this.keywords || this.title || this.abstract || this.statuses) {
                // Force the data to reset before making the query
                this.data = null
                this.loading = true

                let qs = '?' + ((this.title) ? `title=${this.title}&` : '') 
                    + ((this.abstract) ? `abstract=${this.abstract}&` : '') 
                    + ((this.affiliation) ? `affiliation=${this.affiliation}&` : '') 
                    + ((this.keywords) ? `keywords=${this.keywords}&` : '')
                
                if (this.statuses) {
                    for (let status of this.statuses) {
                        qs += `&statuses=${status.granular_status_id}`
                    }
                }

                if (this.limit) {
                    qs += `&limit=${this.limit}`
                }

                if (this.page) {
                    qs += `&page=${this.page}`
                }

                let result = await axios.get('https://nursing.jmir.org/v1/dashboards/eic' + qs)

                this.data = result.data.authors
                this.count = result.data.count
                this.loading = false;

                this.$forceUpdate()
            }
        },

        left: function() {
            if (this.page != 1 && !this.loading) {
                this.page--
                this.filterResults()
            }
        },

        right: function() {
            if (this.page != Math.ceil(this.count / this.limit) && !this.loading) {
                this.page++
                this.filterResults()
            }
        }
    },
    computed: {
        getPages: function() {
            return Math.ceil(this.count / this.limit)
        }
    }

}
</script>

<style scoped>
    .filters {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .filter-row {
        display: flex;
        width: 100%;
    }

    .list-row {
        display: flex;
        flex-direction: column;
    }
    
    .filter {
        margin: 8px 8px 8px 0;
        padding: 5px 8px;
        display: inline-block;
        border-radius: 5px !important;
        border: 1px solid #ccc;
        box-sizing: border-box;
    }

    .filter-button {
        border: none;
        padding: 4px 8px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 14px;
        margin: 4px 2px;
        cursor: pointer;
        color: black;
        border: 1px solid #ccc;
        border-radius: 5px !important;
    }

    /* LOADING CSS */

    .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }

    .lds-ellipsis div {
        position: absolute;
        top: 33px;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: #c7c7c7;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }

    .lds-ellipsis div:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
    }

    @keyframes lds-ellipsis1 {
        0% { transform: scale(0); }
        100% { transform: scale(1); }
    }

    @keyframes lds-ellipsis3 {
        0% { transform: scale(1); }
        100% { transform: scale(0); }
    }

    @keyframes lds-ellipsis2 {
        0% { transform: translate(0, 0); }
        100% { transform: translate(24px, 0); }
    }
</style>